import EventEmitterEx from './EventEmitterEx'

export default class EventEmitterExGuest extends EventEmitterEx {
}
